module.exports = __webpack_public_path__ + "static/media/avatar-20.a555b6fb.svg";